import {  Tabs, Badge } from 'antd'
import React, { useState } from 'react'
import ExpenseListAdd from './ExpenseListAdd'             
import Main from '../../cpn/Main';
import { PlusOutlined, ClockCircleOutlined, ScheduleOutlined, AuditOutlined, FileDoneOutlined, FileSearchOutlined } from '@ant-design/icons';
import ExpenseListPendding from './ExpenseListPendding';
import ExpenseListSubmitted from './ExpenseListSubmitted';            
import ExpenseListNeedApprove from './ExpenseListNeedApprove';
import ExpenseListApproved from './ExpenseListApproved';
import ExpenseListNeedRead from './ExpenseListNeedRead';
import ExpenseListAll from './ExpenseListAll';
function ExpenseList(props) {
    const qy_id = props.qy_id;
    const qy_name = props.qy_name;
    const yh_id = props.yh_id;
    const yh_name = props.yh_name;
    const yh_qx = props.yh_qx || '';  
    const [list,setList] = React.useState(props.expenseList);
    React.useEffect(() => {
        if (props.expenseList.length > 0) {
            const formattedData = props.expenseList.map((item,index) => ({
                key: item.fy_id,
                fy_content: item.fy_content,
                fy_ctime: item.fy_ctime,
                fy_price: item.fy_price,
                fy_uname: item.fy_uname,
                fy_num: item.fy_num,                  
                fy_uid: item.fy_uid,   
                fy_type_name: item.fy_type_name,               
                fy_kh_name: item.fy_kh_name,               
                fy_amount: item.fy_amount,               
                fy_bzd_danhao:item.fy_bzd_danhao,
                fy_bzd_id:item.fy_bzd_id,
                fy_date:item.fy_date,
                fy_date_end:item.fy_date_end,
                fy_bzd_name:item.fy_bzd_name,
                fy_type_id:item.fy_type_id,
                fy_kh_id:item.fy_kh_id,
                fy_state:item.fy_state,
                fy_bm_id:item.fy_bm_id,
                fy_bm_name:item.fy_bm_name,
                fy_khyhzh_id:item.fy_khyhzh_id,
                fy_khyhzh_name:item.fy_khyhzh_name,
                fy_image_name:item.fy_image_name,
                fy_image_file:item.fy_image_file,
                fy_state_time:item.fy_state_time,
            }));
            const sortedData = formattedData.sort((a, b) => new Date(a.dsbzdsz_ctime) - new Date(b.dsbzdsz_ctime));
            setList(sortedData);
            
        }else{
            setList([])
        }}, [props.expenseList])
    const [activeKey, setActiveKey] = useState(localStorage.getItem('jtg-caiwu_loan_active_key') || '1');
    return (
        <Main 
            selectedKeys={['/ExpenseList']}
            qy_id={props.qy_id}
            qy_name={props.qy_name}
            yh_id={props.yh_id}
            yh_name={props.yh_name}
            loanNeedApproveNum={props.loanNeedApproveNum}
            loanNeedReadNum={props.loanNeedReadNum}
            loanRejectedNum={props.loanRejectedNum}
            loanEndNeedReadNum={props.loanEndNeedReadNum}
            reportRejectedNum={props.reportRejectedNum}
            reportNeedApproveNum={props.reportNeedApproveNum}
            reportNeedReadNum={props.reportNeedReadNum}
            reportEndNeedReadNum={props.reportEndNeedReadNum}
            expenseNeedApproveNum={props.expenseNeedApproveNum}
            expenseNeedReadNum={props.expenseNeedReadNum}
            expenseRejectedNum={props.expenseRejectedNum}
            expenseEndNeedReadNum={props.expenseEndNeedReadNum}
            ddzcNeedApproveNum={props.ddzcNeedApproveNum}
            ddzcNeedReadNum={props.ddzcNeedReadNum}
            ddzcRejectedNum={props.ddzcRejectedNum}
            ddzcEndNeedReadNum={props.ddzcEndNeedReadNum}
            ddsrNeedApproveNum={props.ddsrNeedApproveNum}
            ddsrNeedReadNum={props.ddsrNeedReadNum}
            ddsrRejectedNum={props.ddsrRejectedNum}
            ddsrEndNeedReadNum={props.ddsrEndNeedReadNum}
            invoiceNeedApproveNum={props.invoiceNeedApproveNum}
            invoiceNeedReadNum={props.invoiceNeedReadNum}
            invoiceRejectedNum={props.invoiceRejectedNum}
            invoiceEndNeedReadNum={props.invoiceEndNeedReadNum}
            yh_qx={props.yh_qx}
        >                            
            <Tabs
                activeKey={activeKey} 
                onChange={(key) => {    
                    setActiveKey(key)
                    localStorage.setItem('jtg-caiwu_loan_active_key', key)
                }}
                items={[
                    {
                        key: '0',
                        label: '新增',
                        children: <ExpenseListAdd qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={list} yh_qx={yh_qx}/>,
                        icon: <PlusOutlined />,
                    },
                    {
                        key: '1',
                        label: '我未提交的',
                        children: <ExpenseListPendding qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={list} yh_qx={yh_qx}/>,
                        icon: <ClockCircleOutlined />,
                    },
                    {
                        key: '2',
                        label: <span>我已提交的<Badge count={Number(props.expenseRejectedNum) + Number(props.expenseEndNeedReadNum)}> <span style={{marginLeft:'10px',color:'#fff'}}> 1</span></Badge></span>,
                        children: <ExpenseListSubmitted qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={list} expenseRejectedNum={props.expenseRejectedNum} expenseEndNeedReadNum={props.expenseEndNeedReadNum} yh_qx={yh_qx}/>,
                        icon: <ScheduleOutlined />,
                    },
                    {
                        key: '3',
                        label: <span>需要我审批的<Badge count={props.expenseNeedApproveNum}> <span style={{marginLeft:'10px',color:'#fff'}}> 1</span></Badge></span>,
                        children: <ExpenseListNeedApprove qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={props.expenseSpList} yh_qx={yh_qx}/>,
                        icon: <AuditOutlined />,
                    },
                    {
                        key: '4',
                        label: '我已审批的',
                        children: <ExpenseListApproved qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={props.expenseSpList} yh_qx={yh_qx}/>,
                        icon: <FileDoneOutlined />,
                    },
                    {
                        key: '5',
                        label: <span>抄送给我的<Badge count={props.expenseNeedReadNum}> <span style={{marginLeft:'10px',color:'#fff'}}> 1</span></Badge></span>,
                        children: <ExpenseListNeedRead qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={props.expenseSpList} yh_qx={yh_qx}/>,
                        icon: <FileDoneOutlined />,
                    },
                    ...(yh_qx.includes('管理') ? [{
                        key: '6',
                        label: '全部单据',
                        children: <ExpenseListAll qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={list} yh_qx={yh_qx}/>,
                        icon: <FileSearchOutlined />,
                    }] : []),
                ]}
            />
        </Main>
    )
}

export default ExpenseList